import { Modal } from "react-bootstrap";
import { useContext, useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import LandLordContext from "../../context/landlord/LandLordContext";
import AuthContext from "../../context/auth/AuthContext";
import { toast } from "../../helper/common";
import { useNavigate, useParams } from "react-router-dom";
const BillingCustomization = ({ onClose, onEditBilling }) => {
  const { _t } = useTranslator();
  const { workspaceId } = useParams();

  const { updateWorkspaceBilling } = useContext(LandLordContext);
  const { user, loadUserTenant } = useContext(AuthContext);
  const navigate = useNavigate();

  const saved = user?.current_workspace?.billing_details ?? {};

  const snapshot = {
    billing_type: saved.billing_type || "business",
    company_name: saved.company_name || "",
    full_name: saved.full_name || "",
    tax_id: saved.tax_id || "",
    country: saved.country || "",
    city: saved.city || "",
    address: saved.address || "",
    postal_code: saved.postal_code || "",
  };

  const [billingData, setBillingData] = useState({
    company_name: snapshot.company_name,
    full_name: snapshot.full_name,
    tax_id: snapshot.tax_id,
    country: snapshot.country,
    city: snapshot.city,
    address: snapshot.address,
    postal_code: snapshot.postal_code,
  });

  const {
    company_name,
    full_name,
    tax_id,
    country,
    city,
    address,
    postal_code,
  } = billingData;

  const billingDetails = [
    company_name,
    full_name,
    tax_id,
    country,
    city,
    address,
    postal_code,
  ]
    .filter((item) => item && item.toString().trim() !== "")
    .join(", ");
  const handleViewAllInvoices = () => {
    navigate(`/${workspaceId}/credits-ledger`);
  };
  return (
    <Modal.Body className="billing-tab">
      {/* ── Payment Details ── */}
      <h4 className="billing-summary__section-title">{_t("paymentDetails")}</h4>

      <div className="billing-summary__row">
        <div className="billing-summary__info">
          <span className="billing-summary__billed-label mt-2">
            {_t("billedTo")}
          </span>
          <span className="billing-summary__address company-name-text">
            {billingDetails || _t("dataNotAvailable")}
          </span>
        </div>
        <button
          type="button"
          className="billing-summary__edit-btn btnNext basicInfoButton greenHover"
          onClick={onEditBilling}
        >
          {_t("editInformation")}
        </button>
      </div>

      {/* ── Invoices ── */}
      <h4 className="billing-summary__section-title">{_t("invoices")}</h4>

      <div
        className="billing-summary__row billing-summary__row--invoices"
        onClick={() => {
          onClose();
          handleViewAllInvoices();
        }}
        style={{ cursor: "pointer" }}
      >
        <p className="company-name-text company-name-width m-0">
          {_t("billingDetailsDescription")}
        </p>

        <span className="billing-summary__view-link">
          {_t("viewAllInvoices")}&nbsp;&rarr;
        </span>
      </div>
    </Modal.Body>
  );
};

export default BillingCustomization;
